import { Routes, Route, Navigate } from "react-router-dom";

import HallOfEntities from "../../pages/my-cropwise";
import Protocols from "../../pages/protocols";
import CreateProtocol from "../../pages/create-protocol";
import TrialsList from "../../pages/trials";
import CreateTrials from "../../pages/new-trail";
import { NewTrialStateProvider } from "../../pages/new-trail/hooks/NewTrialStateProvider";
import { useLDConfig } from "../../context/LDFlagsContext";
import { appURLs } from "./appUrls";

/**
 * define routes for the application
 * @returns routes for the application
 */
export const AppRoutes = (): JSX.Element => {
  useLDConfig();
  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate to={appURLs.MY_CROPWISE} replace={true} />}
      />
      <Route path={appURLs.MY_CROPWISE + "/*"} element={<HallOfEntities />} />
      <Route
        path={appURLs.HOME + "/*"}
        element={<Navigate to={appURLs.MY_CROPWISE} replace={true} />}
      />
      <Route
        path={
          appURLs.TRIALS +
          "/workspace/:workspaceId/org/:orgId/farm/:farmId" +
          "/*"
        }
        element={
          <NewTrialStateProvider>
            <TrialsList />
          </NewTrialStateProvider>
        }
      />
      <Route
        path={
          appURLs.TRIALS +
          "/workspace/:workspaceId/org/:orgId/farm/:farmId/create"
        }
        element={
          <NewTrialStateProvider>
            <CreateTrials />
          </NewTrialStateProvider>
        }
      />
      <Route
        path={
          appURLs.TRIALS +
          "/workspace/:workspaceId/org/:orgId/farm/:farmId/trial/:id"
        }
        element={
          <NewTrialStateProvider>
            <CreateTrials />
          </NewTrialStateProvider>
        }
      />
      <Route
        path={
          appURLs.PROTOCOLS +
          "/workspace/:workspaceId/org/:orgId/farm/:farmId" +
          "/*"
        }
        element={<Protocols />}
      />
      <Route
        path={
          appURLs.PROTOCOLS +
          "/workspace/:workspaceId/org/:orgId/farm/:farmId/create/:step"
        }
        element={<CreateProtocol />}
      />
      <Route
        path={
          appURLs.PROTOCOLS +
          "/workspace/:workspaceId/org/:orgId/farm/:farmId/protocol/:protocolId/:step"
        }
        element={<CreateProtocol />}
      />
    </Routes>
  );
};
